export function toPlainString(num: number): string {
  const str = String(num);

  if (!/e/i.test(str)) return str;

  const [mantissa, exponent] = str.split("e");
  const exp = parseInt(exponent, 10);

  const [sign, digitsRaw] = mantissa.startsWith("-")
    ? ["-", mantissa.slice(1)]
    : ["", mantissa];

  const [intPart, fracPart = ""] = digitsRaw.split(".");
  const digits = intPart + fracPart;

  if (exp >= 0) {
    const i = intPart.length + exp;
    const full = digits.padEnd(i, "0");
    return sign + full + (i < full.length ? "." + full.slice(i) : "");
  } else {
    const i = intPart.length + exp;
    if (i > 0) {
      return sign + intPart.slice(0, i) + "." + intPart.slice(i) + fracPart;
    } else {
      return sign + "0." + "0".repeat(-i) + intPart + fracPart;
    }
  }
}

export const addCommasToNumber = (
  number: number | string,
  decimalPlaces?: number
): string => {
  try {
    if (Number.isNaN(+number)) {
      throw new Error("Not a valid number");
    }

    const num = toPlainString(+number);

    // eslint-disable-next-line prefer-const
    let [integerPart, decimalPart = ""] = num.split(".");

    if (typeof decimalPlaces === "number") {
      if (decimalPlaces > 0) {
        decimalPart = decimalPart.slice(0, decimalPlaces);
      } else {
        decimalPart = "";
      }
    }

    const integerWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    // Nếu không truyền decimalPlaces -> hiển thị hết phần thập phân
    return decimalPart ? `${integerWithCommas}.${decimalPart}` : integerWithCommas;
  } catch {
    return "0";
  }
};

export function convertAddress(locationInfo, hideAddress = false) {
  if (!locationInfo) return ''
  const { address, district, ward, province } = locationInfo
  const getValue = (data: string | { title: string; id: number }) => {
    return typeof data === 'string' ? data : data?.title ?? ''
  }

  const result = [getValue(address), getValue(ward), getValue(district), getValue(province)]
  if (hideAddress) result.shift()

  return result.filter((item) => item).join(', ')
}

export function shakeUndifindedItem<T>(set: Set<T>): Set<NonNullable<T>>
export function shakeUndifindedItem<T>(arr: T[]): NonNullable<T>[]
export function shakeUndifindedItem<T>(target: T[] | Set<T>): any {
  if (Array.isArray(target)) {
    return target.filter((item) => item != null) as NonNullable<T>[]
  } else {
    const newSet = new Set(target)
    newSet.delete(undefined as any)
    return newSet as Set<NonNullable<T>>
  }
}

export function getRootUrl(
  options = {
    withPathName: false,
  }
) {
  if (typeof window !== undefined) {
    if (options.withPathName) {
      return window.location.protocol + '//' + window.location.hostname + window.location.pathname
    }
    return window.location.protocol + '//' + window.location.hostname
  }
  return ''
}